import React from "react";

export const Logo = (props) => {
  return <div className={"logo " + (props.className || "")}>
    <img src={`https://client-upload.bytehogs.com/bhg/brand/${props.mobile ? "bytehogs_logo" : "bytehogs_logo"}.svg`} alt="Logo" />
    <span>admin</span>
  </div>
};
